import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=79b7ac11&scoped=true"
import script from "./Result.vue?vue&type=script&setup=true&lang=js"
export * from "./Result.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=79b7ac11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b7ac11",
  null
  
)

export default component.exports